<div class="ui-tab w-100 h-100 flex-col gap-16">
  @if (!group()) {
    <div class="w-100 h-100 flex-1">
      <ui-preloader [color]="loaderColor.blue"></ui-preloader>
    </div>
  } @else {
    <div class="flex-row space-between-center vehicle-group-details-toolbar">
      <div class="vehicle-group-details-toolbar-left flex-row start-center gap-8 min-w-0">
        <span class="vehicle-group-details-name">{{ group().name }}</span>
        @if (canRenameVehicleGroup()) {
          <ui-button
            type="noBorderDefault"
            iconClass="ui-icon-edit"
            [attr.aria-label]="'VEHICLE_GROUPS.DETAIL.EDIT_NAME' | translate"
            (click)="editName()"></ui-button>
        }
      </div>
      @if (canEditGroupMembers()) {
        <div class="vehicle-group-details-toolbar-right flex-row center-center gap-16">
          <ui-button
            type="default"
            iconClass="ui-icon-plus"
            [text]="'VEHICLE_GROUPS.DETAIL.ADD_VEHICLES' | translate"
            [disabled]="isVehicleGroupMembersLoading()"
            (click)="addVehicles()">
          </ui-button>
<!--          <ui-button-->
<!--            iconClass="ui-icon-globe"-->
<!--            [text]="'VEHICLE_GROUPS.DETAIL.SHARE_GROUP' | translate"-->
<!--            (click)="shareGroup()">-->
<!--          </ui-button>-->
        </div>
      }
    </div>

    <div class="vehicle-group-members-content flex-col w-100 h-100 min-h-0 flex-1">
      @switch (membersViewState()) {
        @case (viewStates.HAS_CONTENT) {
          <app-vehicles-table
            #membersTable
            [vehicles]="members()"
            [canEdit]="canEditGroupMembers()"
            [deleteTooltip]="removeFromGroupTooltip"
            [onRemove]="canEditGroupMembers() ? removeMemberFromGroup : undefined"
          ></app-vehicles-table>
        }
        @case (viewStates.INITIAL_EMPTY) {
          @if (isVehicleGroupDetailsLoading() || isVehicleGroupMembersLoading()) {
            <ui-preloader [color]="loaderColor.blue"></ui-preloader>
          } @else {
            <ui-no-data
              [imgSrc]="noData.noMembers.imgSrc"
              [title]="noData.noMembers.title | translate"
            ></ui-no-data>
          }
        }
      }
    </div>
    @if (canEditGroupMembers() && selectedPlatesCount() > 0) {
      <ui-selected-items-snackbar
        [counter]="selectedPlatesCount()"
        [selectedText]="'VEHICLES.VEHICLES_SELECTED'"
        (selectAll)="selectAllDisplayedVehicles()"
        (clearAll)="clearSelectedVehicles()"
      >
        <ui-button
          [text]="'COMMON.DELETE' | translate"
          type="secondary"
          (clickAction)="removeSelectedMembers()"
        ></ui-button>
      </ui-selected-items-snackbar>
    }
  }
</div>
